// src/lib/mengen-plan.ts
// Modul 26 B: Uebersetzt „diese Zeile soll X Kartons bringen" in den richtigen
// Aufruf von POST /warehouse/fillup/request/.
//
// Der Punkt, an dem man sich vertut: die Listenzeile zeigt die Menge der OFFENEN
// POSITION, `mode:'set'` setzt aber die GESAMTMENGE der Anforderung. Solange nichts
// geholt wurde, ist beides dieselbe Zahl; sobald ein Teil erledigt ist, nicht mehr.
// Deshalb:
//   * ERHOEHEN laeuft ueber `add` mit dem Delta. Das ist in beiden Faellen exakt und
//     braucht keine Kenntnis darueber, was schon geholt wurde (seit Modul 26 A zieht
//     `add` die offene Position mit).
//   * SENKEN braucht die Gesamtmenge, denn `add` kann nicht negativ sein (das Schema
//     laesst nur 0..999, und 0 ist das Storno). Die Gesamtmenge steht in der Vorschau
//     (`GET /fillup/request/preview/` -> `open_request.cartons`).

/** Obergrenze aus fillupRequestSchema (src/modules/warehouse/types.ts). */
export const SCHEMA_MAX_CARTONS = 999

export type Mengenplan =
  | { modus: 'keine' }
  | { modus: 'add'; cartons: number }
  | { modus: 'set'; cartons: number }
  /** Senkung ohne belastbare Gesamtmenge — es wird NICHT geraten. */
  | { modus: 'unbekannt' }
  /** Die noetige Gesamtmenge liegt ueber der Schemagrenze (999). */
  | { modus: 'zu_gross'; cartons: number }

export function planeMengenAenderung(
  alteZeilenmenge: number,
  neueZeilenmenge: number,
  gesamtVorher: number | null,
): Mengenplan {
  if (neueZeilenmenge === alteZeilenmenge) return { modus: 'keine' }
  if (neueZeilenmenge > alteZeilenmenge) {
    return { modus: 'add', cartons: neueZeilenmenge - alteZeilenmenge }
  }
  // Senkung: bereits geholt = Gesamtmenge − offene Position.
  if (gesamtVorher === null || gesamtVorher < alteZeilenmenge) return { modus: 'unbekannt' }
  const bereitsGeholt = gesamtVorher - alteZeilenmenge
  const ziel = bereitsGeholt + neueZeilenmenge
  // `add` deckelt nur das uebertragene Delta auf 999, nicht die Summe — eine
  // Anforderung kann also ueber 999 stehen. `set` unterliegt der Schemagrenze und
  // wuerde mit HTTP 400 abgewiesen (Codex-Review 2026-08-04, Befund 4). Lieber
  // vorher sagen, was los ist, als den Bediener in einen nackten Fehler laufen zu lassen.
  if (ziel > SCHEMA_MAX_CARTONS) return { modus: 'zu_gross', cartons: ziel }
  return { modus: 'set', cartons: ziel }
}
